export enum KoppelingSoort {
    Alles = 0,
    Werkbon = 1,
    Paragraaf = 2,
    Installatie = 3,
    Object = 4,
    Project = 5,
    Factuur = 6,
    Brief = 7,
    Apparaat = 8,
    Actie = 9,
    Urenstaat = 10,
    Abonnement = 11
}
